<template>
  <div 
    v-if="relatedDocuments.length > 0" 
    id="RelatedDocumentsMenu" 
    class="related-documents-menu"
  >
    <div class="nav-sub">
      <h4>
        Related Documents
      </h4>
      <ul>
        <li v-for="relatedDocument in relatedDocuments" :key="relatedDocument.Content">
          <a 
            :href="GetRelatedDocumentUrl(relatedDocument.Content)"    
            target="_blank"
            class="break-word related-documents-menu__file"
          >
            <fa-icon :icon="getFileTypeIcon(relatedDocument.DetailProperties.FileType)" class="related-documents-menu__file-icon" />
            <span class="related-documents-menu__file-name">
              {{ relatedDocument.DetailProperties.Title }}
            </span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import { CatalogService }  from "@/services/CatalogService"
  import { controlsHelper }  from "@/components/mixins/commonControlsHelper"
  import { ErrorLogService } from "@/services/ErrorLogService"
  import { constants }       from "@/const"
  import { brandAndRegionAuthHelper } from "@/components/mixins"

  export default {
    mixins: [controlsHelper, brandAndRegionAuthHelper],
    props: {
      categoryId: null
    },
    data: () => ({
      relatedDocuments: []
    }),
    created() {
      CatalogService.GetCategoryContentByTypes(this.categoryId, [constants.CATEGORY_CONTENT_TYPES.RELATED_DOCUMENT] )
        .then(result => {
          var relatedDocs = result.data.filter(doc => 
            doc.ContentType === constants.CATEGORY_CONTENT_TYPES.RELATED_DOCUMENT &&
            this.IsNotNullOrUndefined(doc, ("DetailProperties.BrandAuth")) &&
            this.IsNotNullOrUndefined(doc, ("DetailProperties.RegionAuth")) &&
            this.IsBrandRegionAuthorized(doc.DetailProperties.BrandAuth, doc.DetailProperties.RegionAuth)
          );
          this.relatedDocuments = relatedDocs;
          if(this.relatedDocuments.length === 0){
            this.$emit("foundNoRelatedDocuments");
          }
        }).catch(err => {
          ErrorLogService.LogException(err);
        });
    },
    methods:{
      GetRelatedDocumentUrl(fileId){
        return CatalogService.GetMediaUrl(fileId);
      }
    },
  }
</script>
<style lang="scss">
.related-documents-menu__no-docs-message{
  padding: 0 12px;
}
.related-documents-menu__file{
  font-size: 12px;
  position: relative;
}
.related-documents-menu__file-icon{
  float: left;
  font-size: 24px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.related-documents-menu__file-name{
  display: flex;
  padding-left: 4px;
  margin-left: 18px;
}
#RelatedDocumentsMenu {
  width: 100%;
}
</style>
